const getPreferenceCenterCountrySelect = require("./getPreferenceCenterCountrySelect");

/**
 * @param preferenceCenter {HTMLElement}
 * @return {void}
 */
module.exports = function setPreferenceCenterCountryToUS(preferenceCenter) {
    const countrySelect = getPreferenceCenterCountrySelect(preferenceCenter);
    countrySelect.value = "United States";
}